import { useDispatch } from 'react-redux'

import config from '../../config'
import * as api from '../api'
import { useSession } from '../session'
import { userActions } from '../store'
import useInvalidate from '../useInvalidate'
import useApiMutation from './useApiMutation'

export interface UpdateUserAvatarArguments {
  uuid: string
  imageData: string | null
}

export default function useUpdateUserAvatar() {
  const dispatch = useDispatch()
  const session = useSession()
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async (data: UpdateUserAvatarArguments) => {
      await api.patch(`user/${encodeURIComponent(data.uuid)}/image`, {
        image: data.imageData ? data.imageData.replace(/^[^,]+,/, '') : null,
      })

      dispatch(userActions.update({ uuid: data.uuid, avatarUrl: data.imageData }))

      // Force reload of the image. FIXME Does not work in Firefox
      fetch(new URL(`user/${data.uuid}/image`, config.apiUrl), { cache: 'reload', mode: 'no-cors' })
      const url = new URL(`user/${data.uuid}/image`, config.apiUrl).toString()
      document.body.querySelectorAll(`img[src='${url}']`).forEach((img) => ((img as any).src = url))

      await invalidate.users()
      session.invalidate()
    },
  })
}
